import { LazyRoute } from "common/routes/route.types";
import { routes } from "common/routes/routes";

export const bpMobileRoutes: LazyRoute = {
  ...routes.bpMobile,
  importComponent: () => import("modules/bp-mobile/Index"),
  id: "mobile-layout",
  children: [
    {
      ...routes.bpMobileDashboard.basePath,
      index: true,
      importComponent: () =>
        import("modules/bp-mobile/dashboard/pages/DashboardScreen"),
      id: routes.bpMobileDashboard.basePath.text
    },
    {
      ...routes.bpMobileBooking.bookingCalendar,
      importComponent: () =>
        import("modules/bp-mobile/booking/pages/BookingCalendarScreen"),
      id: routes.bpMobileBooking.bookingCalendar.text
    },
    {
      ...routes.bpMobileBooking.appointments,
      importComponent: () =>
        import("modules/bp-mobile/booking/pages/ScheduleScreen"),
      id: routes.bpMobileBooking.appointments.text
    },
    {
      ...routes.bpMobileClinicalRecord.view,
      importComponent: () =>
        import("modules/bp-mobile/clinical/pages/ClinicalRecordScreen"),
      id: routes.bpMobileClinicalRecord.view.text
    },
    {
      ...routes.bpMobileClinicalRecord.edit,
      importComponent: () =>
        import("modules/bp-mobile/clinical/pages/ClinicalRecordEditScreen"),
      id: routes.bpMobileClinicalRecord.edit.text
    },
    {
      ...routes.bpMobileTodo.userInbox,
      importComponent: () =>
        import("modules/bp-mobile/inbox/pages/InboxScreen"),
      id: routes.bpMobileTodo.userInbox.text
    },
    {
      ...routes.bpMobileAddressBook.patients,
      importComponent: () =>
        import("modules/bp-mobile/practice/pages/AddressBookScreen"),
      id: routes.bpMobileAddressBook.patients.text
    },
    {
      ...routes.bpMobileDocumentEditor.edit,
      importComponent: () =>
        import("modules/bp-mobile/document-editor/pages/DocumentEditorScreen"),
      id: routes.bpMobileDocumentEditor.edit.text
    }
  ]
};
